import {APIResponse} from "services/HttpService";
import {DatasetDataInfoResponse} from "api/apiModels";
import {PlotDataEx} from "components/dashboard/charts/interfaces";

export const APIResponseToDatasetDataInfoResponseArray = (res: APIResponse<any>): PlotDataEx[] => {
    const resultData = res.data;
    if (!resultData || (resultData && resultData.length === 0)) {
        return []
    }

    return DatasetDataInfoResponseArrayToPlotDataExArray(resultData)
}

export const DatasetDataInfoResponseArrayToPlotDataExArray = (data: DatasetDataInfoResponse[] | undefined): PlotDataEx[] => {
    const d = data?.map((data: DatasetDataInfoResponse) => {
        const unit = ` ${data.unit as string}` || "";

        if (data.data.length === 0) {
            return undefined
        }

        const extractedData = data.data.map(val => {
            const date = new Date(val.key)
            date.setMilliseconds(0)
            return {x: date, y: val.value.toFixed(1)}
        })

        return {
            x: extractedData.map(e => e.x),
            y: extractedData.map(e => e.y),
            unit: unit,
            type: 'bar',
            hovertemplate: `%{y}${unit} at %{x}<br>${data.title}<extra></extra>`,
            text: extractedData.map(e => e.y.toString()),
            name: data.title,
        } as PlotDataEx
    })


    return d ? d.filter(e => e !== undefined) as PlotDataEx[] : []
}